import { render } from "./CadastroUsuario.vue?vue&type=template&id=75130b20&ts=true"
import script from "./CadastroUsuario.vue?vue&type=script&lang=ts"
export * from "./CadastroUsuario.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__